import { styled } from 'styletron-react';
import { staticColors } from '../../../../const/colors/staticColors';
import { sizes } from '../../../../const/sizes';
import { transitionDuration } from '../../../../const/transitionDuration';
import { transitionTimingFunction } from '../../../../const/transitionTimingFunction';
import { getDayBackgroundColor } from './helpers/getDayBackgroundColor';
export const StyledCalendarDay = styled('button', (button) => {
    const selectedOrStandardBackgroundColor = button.$isSelectedDay
        ? staticColors.calendarBackgroundSelectDate
        : staticColors.calendarBackgroundHoverDate;
    const maybeHoverBackgroundColor = button.$isBlockedDay ? undefined : selectedOrStandardBackgroundColor;
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: sizes.calendar.day.dayWidth,
        minHeight: sizes.calendar.day.dayHeight,
        cursor: button.$isBlockedDay ? 'not-allowed' : 'pointer',
        borderRadius: sizes.calendar.day.borderRadius,
        borderColor: button.$isCurrentDay
            ? staticColors.calendarBorderCurrentDate
            : 'none',
        borderWidth: button.$isCurrentDay ? sizes.calendar.day.borderWidth : '0',
        borderStyle: 'solid',
        transitionProperty: 'all',
        transitionTimingFunction: transitionTimingFunction.ease,
        transitionDuration: transitionDuration.medium,
        ':hover': {
            backgroundColor: maybeHoverBackgroundColor,
        },
        ':focus-visible': {
            outline: 'none',
            backgroundColor: maybeHoverBackgroundColor,
        },
        backgroundColor: getDayBackgroundColor({
            isSelectedDay: button.$isSelectedDay,
        }),
    };
});
